<div class="flex justify-center items-center">
  <span
    class="pill"
    [class.run]="fieldValue === 'Run' || fieldValue === 'KO'"
    [class.pass]="fieldValue === 'Pass' || fieldValue === 'KOR'"
    [class.pen]="
      fieldValue === 'Pen' || fieldValue === 'PEN (Stat Negated)' || fieldValue === 'PenSN'
    "
    [class.np]="fieldValue === 'NP'"
    [class.pp]="fieldValue === 'Punt1'"
    [class.pr]="fieldValue === 'PRP'"
    [class.fg]="fieldValue === 'FG'"
    [class.fgb]="fieldValue === 'FGB|XPB'"
  >
    {{ fieldValue }}
  </span>
</div>
